import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'page-content-with-filters',
  templateUrl: './page-content-with-filters.component.html',
  styleUrls: ['./page-content-with-filters.component.scss'],
})
export class PageContentWithFiltersComponent {}
